import { render, staticRenderFns } from "./NewRegister.vue?vue&type=template&id=444765b1&scoped=true"
import script from "./NewRegister.vue?vue&type=script&lang=js"
export * from "./NewRegister.vue?vue&type=script&lang=js"
import style0 from "./NewRegister.vue?vue&type=style&index=0&id=444765b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444765b1",
  null
  
)

export default component.exports